<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="6">
                    <ValidationProvider name="request_details" v-slot="{valid,errors}">
                        <b-form-group :label="$t('request_details')">
                            <b-form-input v-model="request_data.request_details"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="location" v-slot="{valid,errors}">
                        <b-form-group :label="$t('location')">
                            <b-form-input v-model="request_data.location"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="category" v-slot="{valid,errors}">
                        <b-form-group :label="$t('category')">
                            <b-form-input v-model="request_data.category"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="completion_date" v-slot="{valid,errors}">
                        <b-form-group :label="$t('completion_date')">
                            <select-date v-model="request_data.completion_date" :validation-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="urgency" v-slot="{valid,errors}">
                        <b-form-group :label="$t('urgency')">
                            <b-form-input v-model="request_data.urgency"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="2">
                    <b-form-group class="mb-0">
                        <label class="d-none d-md-block">&nbsp;</label>
                        <b-button variant="primary" block @click="save">
                            {{ $t('save').toUpper() }}
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
    // Components

    // Services
    import StudentRequestService from '@/services/StudentRequestService'

    // Other

    export default {
        components: {
        },
        data() {
            return {
                selected: null,
                request_data: {
                    request_details: null,
                    location: null,
                    category: null,
                    completion_date: null,
                    urgency: null,
                }
            }
        },
        methods: {
            async save() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid) {

                    let request_data = {
                        ...this.request_data
                    }
                    this.formLoading = true;
                    StudentRequestService.studentRequest(request_data)
                                .then(response => {
                                    this.$toast.success(this.$t('api.' + response.data.message));
                                    this.$emit('createFormSuccess', true);
                                })
                                .catch(e => {
                                    this.showErrors(e, this.$refs.formModalValidate)
                                })
                                .finally(() => {
                                    this.formLoading = false
                                })
                }
            }
        }
    }
</script>
